import { IconProps } from '.';

export const HeatmapIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.9912 5.3916C14.8286 2.2441 11.8014 0 8.25 0C3.69365 0 0 3.69365 0 8.25C0 11.8014 2.2441 14.8286 5.3916 15.9912C3.92032 14.6219 3 12.6684 3 10.5C3 6.35786 6.35786 3 10.5 3C12.6684 3 14.6219 3.92032 15.9912 5.3916ZM1.5 8.25C1.5 4.52208 4.52208 1.5 8.25 1.5C8.60736 1.5 8.95834 1.52752 9.30078 1.58105C5.28968 2.11523 2.11523 5.28968 1.58105 9.30078C1.52752 8.95834 1.5 8.60736 1.5 8.25ZM16.5001 10.5001C16.5001 7.30857 14.0077 4.69893 10.8634 4.51086C11.5702 5.30568 12.0001 6.35281 12.0001 7.50011C12 9.98531 9.9853 12.0001 7.50011 12.0001C6.35281 12.0001 5.30568 11.5702 4.51085 10.8634C4.69893 14.0077 7.30857 16.5001 10.5001 16.5001C13.8137 16.5001 16.5 13.8137 16.5001 10.5001ZM13.5001 7.50011C13.5001 7.37783 13.4946 7.25637 13.4874 7.13586C14.4149 7.96025 15.0001 9.16179 15.0001 10.5001C15 12.9853 12.9853 15.0001 10.5001 15.0001C9.16178 15.0001 7.96024 14.4149 7.13585 13.4874C7.25636 13.4947 7.37782 13.5001 7.50011 13.5001C10.8137 13.5001 13.5 10.8137 13.5001 7.50011Z'
        fill={color}
      />
      <circle opacity='0.5' cx='7.94995' cy='7.94995' r='2.25' fill={color} />
    </svg>
  );
};
